import { render, staticRenderFns } from "./TheBreadcrumbs.vue?vue&type=template&id=8bc6bfbc&scoped=true"
import script from "./TheBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./TheBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./TheBreadcrumbs.vue?vue&type=style&index=0&id=8bc6bfbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc6bfbc",
  null
  
)

export default component.exports